import React, { useState, useEffect } from "react";
import styles from "./App.module.css";
import {
  selectPlaylistVisible,
  useGetPlaylistQuery,
  setPlaylist,
} from "./appSlice";
import Player from "./player/Player";
import { Provider, useSelector, useDispatch } from "react-redux";
import Playlist from "./playlist/Playlist";
import store from "./store";

function Main() {
  const dispatch = useDispatch();
  const playlistVisible = useSelector(selectPlaylistVisible);
  const [showErrorModal, setShowErrorModal] = useState(false);

  // Extraer playlistId de la URL
  const urlParams = new URLSearchParams(window.location.search);
  let playlistId = urlParams.get("playlistId");
  let artist = urlParams.get("artist");
  let songId = urlParams.get("songId");

  if (!artist) {
    const pathParts = window.location.pathname.split("/");
    if (pathParts.length === 3 && pathParts[1] === "u") {
      artist = pathParts[2];
    }
  }

  if (!artist) {
    if (!playlistId) {
      const pathParts = window.location.pathname.split("/");
      if (pathParts.length === 3 && pathParts[1] === "playlist") {
        playlistId = pathParts[2];
      }
    }
  }

  // Cargar playlist desde API con el playlistId
  const {
    data: apiPlaylist,
    error,
    isLoading,
  } = useGetPlaylistQuery({
    playlistId: playlistId || undefined,
    artist: artist || undefined,
    songId: songId || undefined,
  });

  useEffect(() => {
    if (apiPlaylist && apiPlaylist.length > 0) {
      dispatch(setPlaylist(apiPlaylist));
    }
  }, [apiPlaylist, dispatch]);

  // Log para debugging
  useEffect(() => {
    if (error) {
      console.warn("Error loading playlist from API, using fallback:", error);
      setShowErrorModal(true);
    }
    if (isLoading) {
      console.log(
        `Loading playlist from API${
          playlistId
            ? ` with ID: ${playlistId}`
            : artist
            ? ` with artist: ${artist}`
            : ""
        }...`
      );
    }
  }, [error, isLoading, playlistId]);

  const [x, setX] = useState(0);
  const [y, setY] = useState(0);
  const [originalPosition, setOriginalPosition] = useState({ x: 0, y: 0 });
  const [originalMousePosition, setOriginalMousePosition] = useState({
    x: 0,
    y: 0,
  });
  const [dragged, setDragged] = useState(false);

  const handleMouseMove = (event: React.MouseEvent) => {
    if (!dragged) {
      return;
    }
    event.preventDefault();

    const mouseEvent = event.nativeEvent;
    if (!(mouseEvent instanceof MouseEvent)) {
      throw new Error("Is not mouse event");
    }

    const moveX = mouseEvent.x - originalMousePosition.x;
    const moveY = mouseEvent.y - originalMousePosition.y;

    setX(originalPosition.x + moveX);
    setY(originalPosition.y + moveY);
  };

  const handleMouseUp = (event: React.MouseEvent) => {
    if (!dragged) {
      return;
    }
    event.preventDefault();

    setDragged(false);
  };

  const handleMouseDown = (event: React.MouseEvent) => {
    event.preventDefault();
    const mouseEvent = event.nativeEvent;
    if (!(mouseEvent instanceof MouseEvent)) {
      throw new Error("Is not mouse event");
    }

    setOriginalPosition({ x, y });
    setDragged(true);
    setOriginalMousePosition({ x: mouseEvent.x, y: mouseEvent.y });
  };

  if (showErrorModal) {
    return (
      <div className={styles.modalOverlay}>
        <div className={styles.modalContent}>
          <h2>Error Loading Songs</h2>
          <p>There was an error loading the playlist from the API.</p>
          <p>
            Please visit{" "}
            <a
              href="https://0xfm.com"
              // target="_blank"
              rel="noopener noreferrer"
            >
              0xfm.com
            </a>{" "}
            or tell{" "}
            <a
              href="https://hey.xyz/u/0xjavi"
              // target="_blank"
              rel="noopener noreferrer"
            >
              Javi
            </a>{" "}
            about this error
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      className={styles.app}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      <div
        style={{
          // border: "1px solid red",
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 1000,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          scale: 0.75,
        }}
      >
        <div
          className={styles.player}
          // style={{ left: `calc(100vw / 2 - 548px / 2 + ${x}px)`, top: `calc(100px + ${y}px)` }}
        >
          <Player />
          <div className={styles.dragArea} onMouseDown={handleMouseDown} />
          {playlistVisible && <Playlist />}
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Provider store={store}>
      <Main />
    </Provider>
  );
}

export default App;
